import api from '@/helpers/api';

const API_READ = `/api/member-register`;
const API_EXPORT = `/api/member-register/export`;

export default {
  namespaced: true,
  state: {
    status: '',
    trackers: [],
    errMessage: '',
    meta: {
      page: 1,
      limit: 10,
      total: 1,
    },
    filter: {},
    search: {},
  },
  mutations: {
    request(state) {
      state.status = 'loading';
    },
    success(state) {
      state.status = 'success';
    },
    error(state, { message }) {
      state.status = 'error';
      state.errMessage = message;
    },
    read(state, { trackers, meta }) {
      state.trackers = [...trackers];
      state.meta = { ...meta };
    },
    setFilter(state, data) {
      state.filter = data;
    },
    setSearch(state, data) {
      state.search = data;
    },
  },
  actions: {
    read({ commit }, { meta, filter, search }) {
      commit('request');
      const cleanFilter = {};
      if (filter) {
        Object.entries(filter).forEach(([key, val]) => {
          if (val !== null && val !== undefined && val !== '') {
            cleanFilter[key] = val;
          }
        });
      }

      return new Promise((resolve, reject) => {
        api
          .request('get', API_READ, { meta, search, filter: Object.keys(cleanFilter).length ? cleanFilter : undefined })
          .then((result) => {
            commit('read', {
              trackers: result.data.data.data_res,
              meta: result.data.data.meta,
            });
            commit('success');
            resolve(result.data.data);
          })
          .catch((err) => {
            commit('error', { message: err });
            reject(err);
          });
      });
    },
    exportData(_, { filter, search }) {
      const cleanFilter = {};
      if (filter) {
        Object.entries(filter).forEach(([key, val]) => {
          if (val !== null && val !== undefined && val !== '') {
            cleanFilter[key] = val;
          }
        });
      }

      return new Promise((resolve, reject) => {
        api
          .request('get', API_EXPORT, { filter: Object.keys(cleanFilter).length ? cleanFilter : undefined, search }, { responseType: 'blob' })
          .then((result) => {
            resolve(result.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
